/**
 * host-upcoming — BookingsPage Pending Requests + Upcoming lists.
 *
 * Same visual treatment for both buckets; the status pill surfaces
 * the difference ("Pending" vs "Confirmed" / "Active"). 56×56 listing
 * photo, listing title, customer + date-range meta, amount + status
 * pill on the right. No urgency tag (renter-only, per Commit 2 scope).
 */
import React from 'react';

import { useIntl } from '../../../util/reactIntl';
import ResponsiveImage from '../../ResponsiveImage/ResponsiveImage';
import StatusBadge from '../StatusBadge';
import css from '../TransactionCard.module.css';
import { formatCardDateRange } from '../formatCardDateRange';

const HostUpcomingLayout = ({ data }) => {
  const intl = useIntl();
  const {
    state,
    processName,
    startDate,
    endDate,
    firstImage,
    imageVariants,
    listingTitle,
    customerName,
    emoji,
    payoutCents,
    serviceLabel,
  } = data;

  const amountDisplay =
    typeof payoutCents === 'number' ? `$${(payoutCents / 100).toFixed(2)}` : null;
  const dateRange = formatCardDateRange(intl, startDate, endDate);

  return (
    <div className={`${css.cardRow} ${css.cardFull}`}>
      <div className={css.cardLeft}>
        <div className={css.thumb56}>
          {firstImage && imageVariants.length > 0 ? (
            <ResponsiveImage
              rootClassName={css.thumbImage}
              alt={listingTitle}
              image={firstImage}
              variants={imageVariants}
            />
          ) : (
            <span className={css.thumbEmoji}>{emoji}</span>
          )}
        </div>
        <div className={css.cardBody}>
          <h4 className={css.cardTitle}>{listingTitle}</h4>
          <p className={css.cardMeta}>
            {customerName}
            {dateRange ? ` · ${dateRange}` : ''}
            {serviceLabel ? ` · ${serviceLabel}` : ''}
          </p>
        </div>
      </div>
      <div className={css.cardRight}>
        {amountDisplay ? <div className={css.cardAmount}>{amountDisplay}</div> : null}
        <StatusBadge state={state} processName={processName} role="provider" />
      </div>
    </div>
  );
};

export default HostUpcomingLayout;
